import React from 'react';
import { ReactComponent as DownloadArrow } from '../../../../assets/novosicones/Financeiro/downloading_black_24dp.svg';
import { ReactComponent as BoletoSimples } from '../../../../assets/novosicones/Financeiro/boleto-simples.svg';
import { Spinner } from '../../../StyledComponent';

export default function LoadPdfBoleto({
  parcela,
  loadingPdfBoleto,
  getPDFVisualizarBoleto,
}) {
  return (
    <>
      {parcela.temBoleto && (
        <span
          className='cardParcelas__detalhes__boletoSimples centralized'
          style={{ position: 'relative' }}
        >
          {loadingPdfBoleto && <Spinner />}
          {!loadingPdfBoleto && (
            <>
              <BoletoSimples style={{ fill: '#4D805A' }} />
              {!parcela.temPix && (
                <DownloadArrow
                  onClick={() => {
                    getPDFVisualizarBoleto(
                      parcela.bancoBoleto,
                      parcela.seuNumero
                    );
                  }}
                  className='btnDownloadArrow'
                />
              )}
            </>
          )}
        </span>
      )}
    </>
  );
}
